export default function waitForAllImagesLoaded(win: Window){
    return new Promise<void>(function (resolve, reject){
        setTimeout(() => {
            reject("Waiting for all images to complete loading timed out.");
        }, 5000);

        const images = win.document.images;
        let counter = 0;

        function incrementCounter() {
            if (++counter === images.length ) resolve();
        }

        [].forEach.call(images, function( img: HTMLImageElement ) {
            if(img.complete)
                incrementCounter();
            else
                img.addEventListener( 'load', incrementCounter, false );
        });
    });
}